import { render, staticRenderFns } from "./wxUpload.vue?vue&type=template&id=5f7b61ec&scoped=true&"
import script from "./wxUpload.vue?vue&type=script&lang=js&"
export * from "./wxUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b61ec",
  null
  
)

export default component.exports